import { Column, Row, SectionedCard, StatColumn, Text, TextExternalLink } from "@bridgesplit/ui";
import { VaultAuditItem } from "@bridgesplit/abf-react";
import { formatDate } from "@bridgesplit/utils";

export function AuditCard({ audits }: { audits?: VaultAuditItem[] }) {
    const auditStats = audits?.map((a) => ({
        caption: <AuditName {...a} />,
        value: <AuditLink {...a} />
    }));
    if (audits && audits.length === 0) return null;
    return (
        <SectionedCard title="Audits">
            {!audits ? <AuditRowSkeleton /> : <StatColumn stats={auditStats} />}
        </SectionedCard>
    );
}

function AuditLink(audit: VaultAuditItem) {
    return (
        <TextExternalLink href={audit.reportUrl}>
            <Text variant="body1">{formatDate(audit.auditedAt, "date", { alwaysShowYear: true })}</Text>
        </TextExternalLink>
    );
}

function AuditName(audit: VaultAuditItem) {
    return (
        <Row spacing={1}>
            <Text variant="body1">{audit.name}</Text>
            <Text variant="body2" color="caption">
                {audit.auditor}
            </Text>
        </Row>
    );
}

function AuditRowSkeleton() {
    return (
        <Column spacing={0}>
            <Text variant="body2" loading loadingWidth="140px">
                &nbsp;
            </Text>
            <Text variant="body2" color="caption" loading loadingWidth="200px">
                &nbsp;
            </Text>
        </Column>
    );
}
